import React, {useCallback, useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import ReactDatetime from 'react-datetime'
import moment from 'moment'
import styled from 'styled-components'
import * as my from '../MyForm'
// import './styles.css'

const DatetimeElement = styled.div`
	& {
		${my.stylesReactDatetime}
	}
`

const DataRangeItems = styled.div`
	display: flex;
	gap: 6px;
`

const DataRangeItem = styled.div`
	flex: 1 1;
	margin: 0 2px;
`

export const DateTime = ({
	className = '',
	inputRef = false,
	inline = false,
	defaultValue = new Date(),
	label = '',
	name = '',
	placeholder = '',
	hint = '',
	errorMessage = '',
	validMessage = '',
	dateFormat = "YYYY-MM-DD",
	timeFormat = false,
	viewMode = DateTime.VIEW_MODE.DAYS,
	closeOnSelect = true,
	onChange,
	...rest
}) => {
	const doChange = useCallback((value)=>{
		onChange && onChange(value.format(dateFormat || timeFormat))
	}, [dateFormat, timeFormat, onChange])

	return (
		<my.Elemet data-inline={!!inline} className={`flex-auto} ${className}`}>
			{!!label && (<my.Label data-inline={!!inline}>{label}</my.Label>)}
			<DatetimeElement>
				<ReactDatetime
					data-inline={!!inline}
					data-invalid={!!errorMessage}
					data-valid={!!validMessage}
					closeOnSelect={closeOnSelect}
					dateFormat={dateFormat}
					defaultValue={defaultValue ?? ''}
					input={true}
					inputProps={{
						// ...rest,
						...(inputRef ? {ref: inputRef} : {}),
						readOnly: true,
						name: name,
						className: `cursor-pointer form-input`,
						placeholder: placeholder,
					}}
					key={defaultValue || 'dtkey'}
					timeFormat={timeFormat}
					viewMode={viewMode}
					onChange={doChange}
				/>
			</DatetimeElement>
			{!!errorMessage && (<my.Error data-inline={!!inline}>{errorMessage}</my.Error>)}
			{!!validMessage && (<my.Success data-inline={!!inline}>{validMessage}</my.Success>)}
			{
				!!hint && (
					typeof hint === 'string' 
						? <my.Hint data-inline={!!inline} dangerouslySetInnerHTML={{__html: hint}} />
						: <my.Hint data-inline={!!inline}>{hint}</my.Hint>
				)
			}
		</my.Elemet>
	)
}
DateTime.propTypes = {
	inline: PropTypes.bool,
	label: PropTypes.string,
	name: PropTypes.string,
	placeholder: PropTypes.string,
	hint: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	errorMessage: PropTypes.string,
	validMessage: PropTypes.string,
	closeOnSelect: PropTypes.bool,
	onChange: PropTypes.func
}
DateTime.VIEW_MODE = {
	MONTH: 'months',
	DAYS: 'days',
	TIME: 'time',
}

export const DateTimeRange = ({
	className = '',
	inputRef = false,
	inline = false,
	defaultValue,
	label = '',
	name = '',
	placeholder = '',
	hint = '',
	errorMessage = '',
	validMessage = '',
	dateFormat = 'YYYY-MM-DD',
	closeOnSelect = true,
	onChange,
	...rest
}) => {
	const dvFrom = defaultValue?.from
	const dvTo = defaultValue?.to
	const [dateRange, setDateRange] = useState({
		from: moment(dvFrom).format(dateFormat),
		to: moment(new Date()).format(dateFormat),
	})

	useEffect(()=>{
		let from = dvFrom ? moment(dvFrom).format(dateFormat) : dateRange.from;
		let to = dvTo ? moment(dvTo).format(dateFormat) : dateRange.to;
		setDateRange({from: from, to: to});
	}, [dateFormat, dateRange.from, dateRange.to, dvFrom, dvTo])
	useEffect(()=>{
		onChange && onChange(dateRange)
	}, [dateRange, onChange])

	const doChange = useCallback((field) => (value)=>{
		// setDateRange({...dateRange, [field]: value.utc().format(dateFormat)});
		setDateRange({...dateRange, [field]: value.format(dateFormat)});
	}, [dateFormat, dateRange])
	return (
		<my.Elemet data-inline={!!inline} className={`flex-auto ${className}`}>
			{!!label && (<my.Label data-inline={!!inline}>{label}</my.Label>)}

			<DataRangeItems>
				<DataRangeItem>
					<DatetimeElement>
						<ReactDatetime
							data-inline={!!inline}
							data-invalid={!!errorMessage}
							data-valid={!!validMessage}
							closeOnSelect={closeOnSelect}
							dateFormat={dateFormat}
							defaultValue={dateRange?.from}
							input={true}
							inputProps={{
								// ...rest,
								...(inputRef ? {ref: inputRef} : {}),
								name: `${name}.from`,
								className: `form-input`,
								placeholder,
							}}
							onChange={doChange('from')}
							timeFormat={false}
							viewMode={'days'}
						/>
					</DatetimeElement>
				</DataRangeItem>
				<DataRangeItem>
					<DatetimeElement>
						<ReactDatetime
							data-inline={!!inline}
							data-invalid={!!errorMessage}
							data-valid={!!validMessage}
							closeOnSelect={closeOnSelect}
							dateFormat={dateFormat}
							defaultValue={dateRange?.to}
							input={true}
							inputProps={{
								// ...rest,
								...(inputRef ? {ref: inputRef} : {}),
								name: `${name}.to`,
								className: `form-input`,
								placeholder,
							}}
							onChange={doChange('to')}
							timeFormat={false}
							viewMode={'days'}
						/>
					</DatetimeElement>
				</DataRangeItem>
			</DataRangeItems>

			{!!errorMessage && (<my.Error data-inline={!!inline}>{errorMessage}</my.Error>)}
			{!!validMessage && (<my.Success data-inline={!!inline}>{validMessage}</my.Success>)}
			{
				!!hint && (
					typeof hint === 'string' 
						? <my.Hint data-inline={!!inline} dangerouslySetInnerHTML={{__html: hint}} />
						: <my.Hint data-inline={!!inline}>{hint}</my.Hint>
				)
			}
		</my.Elemet>
	)
}
DateTimeRange.propTypes = {
	inline: PropTypes.bool,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	name: PropTypes.string,
	placeholder: PropTypes.string,
	hint: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	errorMessage: PropTypes.string,
	validMessage: PropTypes.string,
	closeOnSelect: PropTypes.bool,
	onChange: PropTypes.func
}
